module.exports = __webpack_public_path__ + "static/media/scales.f921e8e7.svg";